import { iso8601DurationToLoansTerm } from 'shared/lib';
import type { TLoansContactCustomerData } from 'shared/types/TLoansService';
import type { TOffer } from 'shared/types/TRankingService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Numeric } from 'entities/creditForm/lib/formatters/base';
import { Region } from 'entities/creditForm/lib/formatters/region';

export class CreditPurpose {
  constructor(
    private readonly data: Pick<
      Partial<TCreditFormCommonFields>,
      'amount' | 'period' | 'purpose' | 'region' | 'regionLocationRoute'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  map(
    calculatedValues?: TOffer['calculatedValues'],
  ): Pick<TLoansContactCustomerData, 'amount' | 'purpose' | 'region' | 'term' | 'termUnit' | 'period'> {
    if (calculatedValues) {
      return {
        ...iso8601DurationToLoansTerm(calculatedValues?.term || this.data.period?.value),
        period: calculatedValues.term || this.data.period?.value || '',
        amount: new Numeric(calculatedValues.amount || this.data.amount).format(),
        purpose: this.data.purpose?.value || 'Money',
        region: new Region(this.data.region, this.data.regionLocationRoute || null).map(),
      };
    }

    return {
      ...iso8601DurationToLoansTerm(this.data.period?.value),
      period: this.data.period?.value || '',
      amount: new Numeric(this.data.amount).format(),
      purpose: this.data.purpose?.value || 'Money',
      region: new Region(this.data.region, this.data.regionLocationRoute || null).map(),
    };
  }
}
